import { TableCellProps, WbColumnWidth } from '../types';

type CreateActionsColumnParams<T> = {
  width?: WbColumnWidth;
  renderActions: (rowData: T) => React.ReactNode;
};

export const ACTIONS_COLUMN_ID = '__actions';

export const createActionsColumn = <T,>({
  width = 50,
  renderActions,
}: CreateActionsColumnParams<T>): TableCellProps<T> => {
  return {
    width,
    sortable: false,
    resizable: false,
    uniqueFieldId: ACTIONS_COLUMN_ID,
    headerName: '',
    fieldRender: renderActions,
  };
};
